module.exports = __webpack_public_path__ + "media/win.6e002cf1.mp3";